import { createHigherOrderComponent } from "@wordpress/compose";
import FlexItemControls from "../components/FlexItemControls";

/**
 * Higher Order Component to add flex item controls to all blocks
 */
const withFlexItemControls = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		const { name, clientId } = props;

		// Don't add flex controls to the container itself
		if (name === "sfb/container") {
			return <BlockEdit {...props} />;
		}

		return (
			<>
				<BlockEdit {...props} />
				<FlexItemControls {...props} clientId={clientId} />
			</>
		);
	};
}, "withFlexItemControls");

export default withFlexItemControls;
